<template>
	<div class="assocRightTitle">
		<p style="color: #000000 ;">
			<a :href="apply_link" :style="{color: aColorB,textDecoration:textDecoration}" @mouseover="mouseOver"
				@mouseleave="onmouseLeave">首页</a>
		</p>
		<p style="color: #000000;" v-if="place.two">
			&nbsp;·&nbsp;
			<a :href="detaillink" :style="{color: aColorB,textDecoration:textDecoration2}" @mouseover="mouseOver2"
				@mouseleave="onmouseLeave2">{{place.one}}</a>
		</p>
		<p style="color: #015AAA;" v-if="!place.two">
			&nbsp;·&nbsp;
			<a :href="detaillink" :style="{color: aColorE,textDecoration:textDecoration2}" @mouseover="mouseOver2"
				@mouseleave="onmouseLeave2">{{place.one}}</a>
		</p>
		<p style="color: #015AAA;" v-if="place.two">
			&nbsp;·&nbsp;
			<a :href="lastlink" :style="{color: aColorE,textDecoration:textDecoration3}" @mouseover="mouseOver3"
				@mouseleave="onmouseLeave3">{{place.two}}</a>
		</p>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				lastlink: null,
				apply_link: null,
				aColorB: '#000000',
				aColorE: '#015AAA',
				textDecoration: 'none',
				textDecoration2: 'none',
				textDecoration3: 'none',
			}
		},
		props: {
			place: {
				type: Object,
				default: () => {
					return {
						one: '',
						two: ''
					}
				}
			},
			// 详情页才要回跳
			detailcheck: {
				type: Boolean,
				default: false
			},
			// 面包屑导航
			detaillink: ''
		},
		updated() {
			if (this.detailcheck) {
				this.lastlink = `${this.detaillink}?detail=${this.place.two}`
			}
			this.apply_link = `../index.html`
		},
		methods: {
			// 结合鼠标监听动态添加hover效果
			mouseOver(e) {
				this.textDecoration = 'underline'
			},
			onmouseLeave(e) {
				this.textDecoration = 'none'
			},
			// 2
			mouseOver2(e) {
				if (this.detailcheck) {
					this.textDecoration2 = 'underline'
				}
			},
			onmouseLeave2(e) {
				this.textDecoration2 = 'none'
			},
			// 3
			mouseOver3(e) {
				if (this.detailcheck) {
					this.textDecoration3 = 'underline'
				}
			},
			onmouseLeave3(e) {
				this.textDecoration3 = 'none'
			},
		}
	}
</script>
<style>

</style>
